import React, { useState } from "react";
import PropTypes from "prop-types";
import { initials } from "./utils";

// Avatar that falls back to initials both when there is no image URL and when the
// image fails to load (e.g. a 404'd Cloudinary URL) — the plain <img>/URL-only checks
// used by the cards left broken-image icons when a stored URL was dead.
function SourceAvatar({
  imageUrl,
  name,
  initialsText,
  size,
  borderRadius = "50%",
  background = "#e5e7eb",
  color = "#6b7280",
  fontSize,
  fontWeight = 600,
}) {
  const [imgError, setImgError] = useState(false);
  const box = { width: size, height: size, borderRadius, flexShrink: 0 };

  if (imageUrl && !imgError) {
    return <img src={imageUrl} alt={name} onError={() => setImgError(true)} style={{ ...box, objectFit: "cover" }} />;
  }

  return (
    <div
      style={{
        ...box,
        background,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight,
        fontSize,
      }}
    >
      {initialsText || initials(name)}
    </div>
  );
}

SourceAvatar.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  initialsText: PropTypes.string,
  size: PropTypes.number.isRequired,
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  background: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.number,
};

export default SourceAvatar;
